module.exports = __webpack_public_path__ + "img/xk4.981786c7.png";